import "./indicatorBar.scss";

export function getColor(num: number, inverted = false) {
  const step = Math.min(10, Math.max(1, Math.round((num / 100) * 9)));
  const invertedStep = inverted ? 10 - step : step;

  return `var(--color__scale_${invertedStep})`;
}

export function getColorByRating(num: number) {
  let colorString = "";
  const rounded = 10 - Math.round(num / 10);

  if (rounded >= 0 && rounded < 1) {
    colorString = "--color__scale_1";
  } else if (rounded <= 10) {
    colorString = `--color__scale_${rounded}`;
  } else colorString = `--color__scale_9`;

  return `var(${colorString})`;
}

function ProgressBar({
  value = 0,
  ghostValue,
  ghostClass,
  colorString = "--color__brown300",
  showColor = false,
  inverted = false,
  classes,
}: {
  value: number;
  ghostValue?: number;
  ghostClass?: string;
  colorString?: string;
  showColor?: boolean;
  inverted?: boolean;
  classes?: string;
}) {
  const isAhead = ghostValue !== undefined && ghostValue <= value;

  return (
    <div className={`progress-bar ${classes || ""}`}>
      <div
        className={`progress-indicator ${isAhead ? ghostClass : ""}`}
        style={{
          width: `${value}%`,
          backgroundColor: isAhead
            ? undefined
            : showColor
              ? getColor(value, inverted)
              : `var(${colorString})`,
        }}
      ></div>
      {ghostValue && (
        <div
          className={`progress-indicator-ghost ${!isAhead && ghostClass}`}
          style={{
            width: `${ghostValue}%`,
            zIndex: isAhead ? 5 : 1,
          }}
        ></div>
      )}
    </div>
  );
}

export default ProgressBar;
